function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M41.9827 39.9004H4.4466C2.74371 39.9004 1.36328 38.52 1.36328 36.8171V8.79438C1.36328 7.09149 2.74371 5.71106 4.4466 5.71106H41.9827C43.6856 5.71106 45.0661 7.09149 45.0661 8.79438V36.8171C45.0661 38.5199 43.6855 39.9004 41.9827 39.9004Z",
  fill: "#C9E0FF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M41.98 5.71106H23.207V39.9004H41.98C43.6829 39.9004 45.0634 38.52 45.0634 36.8171V8.79438C45.0634 7.09149 43.6829 5.71106 41.98 5.71106Z",
  fill: "#FF991F"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M1.36328 22.8057V36.8171C1.36328 38.52 2.74371 39.9004 4.4466 39.9004H41.9827C43.6856 39.9004 45.066 38.52 45.066 36.8171V22.8057H1.36328Z",
  fill: "#FFB256"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M23.207 22.8057V39.9004H41.98C43.6829 39.9004 45.0634 38.52 45.0634 36.8171V22.8057H23.207Z",
  fill: "#00215A"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M15.6797 49.315L17.1579 39.9005H29.2033L30.5299 49.3139L15.6797 49.315Z",
  fill: "#004DB6"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M23.207 49.3149L30.5345 49.3144L29.2078 39.9009H23.207V49.3149Z",
  fill: "#192B80"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M33.9602 50.6667H12.4532C11.7024 50.6667 11.0938 50.058 11.0938 49.3072C11.0938 48.5564 11.7024 47.9477 12.4532 47.9477H33.9602C34.711 47.9477 35.3197 48.5564 35.3197 49.3072C35.3197 50.058 34.711 50.6667 33.9602 50.6667Z",
  fill: "#0089FF"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M33.9654 47.9478H23.207V50.6667H33.9654C34.7162 50.6667 35.3249 50.058 35.3249 49.3072C35.3249 48.5564 34.7162 47.9478 33.9654 47.9478Z",
  fill: "#295FCC"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8184 33.4169C35.5518 33.4169 36.9571 32.0116 36.9571 30.2782C36.9571 28.5447 35.5518 27.1395 33.8184 27.1395C32.0849 27.1395 30.6797 28.5447 30.6797 30.2782C30.6797 32.0116 32.0849 33.4169 33.8184 33.4169Z",
  fill: "#FFCC99"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8203 27.1395V33.4169C35.5537 33.4169 36.959 32.0116 36.959 30.2782C36.959 28.5447 35.5537 27.1395 33.8203 27.1395Z",
  fill: "#FFB366"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M35.852 33.9023H31.7337L31.7335 33.9029C29.995 33.9166 28.5898 35.3296 28.5898 37.0713V37.7828C28.5898 38.2411 28.9613 38.6126 29.4197 38.6126H38.1912C38.6495 38.6126 39.021 38.2411 39.021 37.7828V37.0713C39.021 35.3211 37.6022 33.9023 35.852 33.9023Z",
  fill: "#7AFFE4"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M35.8577 33.9023H33.8203V38.6126H38.197C38.6553 38.6126 39.0268 38.2411 39.0268 37.7828V37.0713C39.0268 35.3211 37.6079 33.9023 35.8577 33.9023Z",
  fill: "#00ECCE"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M12.6582 33.4169C14.3917 33.4169 15.7969 32.0116 15.7969 30.2782C15.7969 28.5447 14.3917 27.1395 12.6582 27.1395C10.9248 27.1395 9.51953 28.5447 9.51953 30.2782C9.51953 32.0116 10.9248 33.4169 12.6582 33.4169Z",
  fill: "#FFF6ED"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M12.6602 27.1395V33.4169C14.3936 33.4169 15.7989 32.0116 15.7989 30.2782C15.7989 28.5447 14.3936 27.1395 12.6602 27.1395Z",
  fill: "#FFDEBD"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M14.6996 33.9023H10.5814C8.84285 33.916 7.4375 35.3296 7.4375 37.0713V37.7828C7.4375 38.2411 7.809 38.6126 8.26733 38.6126H17.0388C17.4972 38.6126 17.8687 38.2411 17.8687 37.7828V37.0713C17.8687 35.3211 16.4498 33.9023 14.6996 33.9023Z",
  fill: "#FF904B"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M14.6976 33.9023H12.6602V38.6126H17.0368C17.4951 38.6126 17.8666 38.2411 17.8666 37.7828V37.0713C17.8666 35.3211 16.4478 33.9023 14.6976 33.9023Z",
  fill: "#FF641A"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8184 17.6087C35.5518 17.6087 36.9571 16.2035 36.9571 14.47C36.9571 12.7365 35.5518 11.3313 33.8184 11.3313C32.0849 11.3313 30.6797 12.7365 30.6797 14.47C30.6797 16.2035 32.0849 17.6087 33.8184 17.6087Z",
  fill: "#FFF6ED"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8203 11.3313V17.6087C35.5537 17.6087 36.959 16.2034 36.959 14.47C36.959 12.7366 35.5537 11.3313 33.8203 11.3313Z",
  fill: "#FFE7CE"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M35.852 18.0941H31.7337L31.7335 18.0948C29.995 18.1084 28.5898 19.5214 28.5898 21.2632V21.9746C28.5898 22.433 28.9613 22.8045 29.4197 22.8045H38.1912C38.6495 22.8045 39.021 22.433 39.021 21.9746V21.2632C39.021 19.513 37.6022 18.0941 35.852 18.0941Z",
  fill: "#E65849"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M35.8577 18.0941H33.8203V22.8045H38.197C38.6553 22.8045 39.0268 22.433 39.0268 21.9746V21.2632C39.0268 19.513 37.6079 18.0941 35.8577 18.0941Z",
  fill: "#C22B1B"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M12.6582 17.6087C14.3917 17.6087 15.7969 16.2035 15.7969 14.47C15.7969 12.7365 14.3917 11.3313 12.6582 11.3313C10.9248 11.3313 9.51953 12.7365 9.51953 14.47C9.51953 16.2035 10.9248 17.6087 12.6582 17.6087Z",
  fill: "#FFCC99"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M12.6602 11.3313V17.6087C14.3936 17.6087 15.7989 16.2034 15.7989 14.47C15.7989 12.7366 14.3936 11.3313 12.6602 11.3313Z",
  fill: "#FFB366"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M14.6996 18.0941H10.5814L10.5812 18.0948C8.84267 18.1084 7.4375 19.5214 7.4375 21.2632V21.9746C7.4375 22.433 7.809 22.8045 8.26733 22.8045H17.0388C17.4972 22.8045 17.8687 22.433 17.8687 21.9746V21.2632C17.8687 19.513 16.4498 18.0941 14.6996 18.0941Z",
  fill: "#005AE0"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M14.6976 18.0941H12.6602V22.8045H17.0368C17.4951 22.8045 17.8666 22.433 17.8666 21.9746V21.2632C17.8666 19.513 16.4478 18.0941 14.6976 18.0941Z",
  fill: "#08418F"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M42.3382 41.2599H4.08354C1.82824 41.2599 0 39.4316 0 37.1763V8.43502C0 6.1798 1.82824 4.35156 4.08354 4.35156H42.3383C44.5935 4.35156 46.4218 6.1798 46.4218 8.43502V37.1764C46.4217 39.4316 44.5934 41.2599 42.3382 41.2599ZM4.08354 7.07054C3.32993 7.07054 2.71898 7.68141 2.71898 8.43502V37.1763C2.71898 37.93 3.32993 38.5409 4.08354 38.5409H42.3382C43.0918 38.5409 43.7028 37.93 43.7028 37.1763V8.43502C43.7028 7.68141 43.0918 7.07045 42.3382 7.07045H4.08354V7.07054Z",
  fill: "#0089FF"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M42.6817 4.35156H23.207V7.07054H42.6817C43.2462 7.07054 43.7038 7.52815 43.7038 8.09261V37.0909C43.7038 37.8917 43.0546 38.5409 42.2538 38.5409H23.207V41.2599H42.6817C44.7479 41.2599 46.4228 39.585 46.4228 37.5188V8.09261C46.4228 6.02645 44.7479 4.35156 42.6817 4.35156Z",
  fill: "#295FCC"
});

var _ref28 = /*#__PURE__*/React.createElement("rect", {
  x: 36.1016,
  y: 4.29834,
  width: 12.0352,
  height: 9.45627,
  fill: "#E5F0FF"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M40.8308 0C45.3405 0 48.9976 3.65711 48.9976 8.16678C48.9976 12.6764 45.3405 16.3336 40.8308 16.3336C36.3212 16.3336 32.6641 12.6764 32.6641 8.16678C32.6641 3.65711 36.3212 0 40.8308 0ZM36.7031 11.1228L39.6591 8.16678L36.7031 5.21072C36.5335 5.04109 36.5335 4.76438 36.7031 4.59481L37.2589 4.03902C37.4284 3.86944 37.7051 3.86944 37.8748 4.03902L40.8308 6.99507L43.7869 4.03902C43.9565 3.86944 44.2332 3.86944 44.4028 4.03902L44.9586 4.59481C45.1282 4.76438 45.1282 5.04109 44.9586 5.21072L42.0025 8.16678L44.9586 11.1228C45.1282 11.2925 45.1282 11.5692 44.9586 11.7387L44.4028 12.2945C44.2332 12.4641 43.9565 12.4641 43.7869 12.2945L40.8308 9.33848L37.8748 12.2945C37.7051 12.4641 37.4284 12.4641 37.2589 12.2945L36.7031 11.7387C36.5335 11.5692 36.5335 11.2925 36.7031 11.1228Z",
  fill: "#FF4141"
});

var SvgCancelMeeting = function SvgCancelMeeting(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 51,
    viewBox: "0 0 49 51",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCancelMeeting, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cancelMeeting.86317d3e.svg";
export { ForwardRef as ReactComponent };